// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".copyright[data-v-f5d81478]{color:var(--font-color)}", ""]);
// Exports
module.exports = exports;
